import Footer from "components/Footer"
import DashboardLayout from "./DashboardLayout"
import { useRecoilValue } from "recoil"
import Http500 from "layouts/error/500"
import PageLayout from "./PageLayout"
import { HttpStatus } from "schemas"
import MDBox from "components/MDBox"
import Http404 from "layouts/error/404"
import Http403 from "layouts/error/403"
import DashboardNavbar from "components/Navbars/DashboardNavbar"

export default function Layout({ children }) {
    const status = useRecoilValue(HttpStatus)
    const pages = { 500: <Http500 />, 404: <Http404 />, 403: <Http403 /> }

    return (
        <>
            {status != 200 ?
                <PageLayout>
                    <MDBox py={0}>
                        {pages[status]}
                    </MDBox>
                </PageLayout>
                :
                <DashboardLayout>
                    <DashboardNavbar />
                    {children}
                    <Footer />
                </DashboardLayout>
            }
        </>
    )
}